var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.params.node.data.id)?_c('button',{staticClass:"btn btn-info",staticStyle:{"height":"20px","line-height":"0.5","width":"30px"},on:{"click":_vm.invokeParentMethod}},[_vm._v("+")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }